// extracted by mini-css-extract-plugin
export default {"disabledForPreviewModelsPanel":"KnowledgeSelectPanel-module__disabledForPreviewModelsPanel--NqDvF"};